import React from "react";
import "./PollOptionsEdit.scss";
import AsyncCreatableSelect from "react-select/async-creatable";
import { API_URL } from "../../utils/axios";
import axios from "axios";



const PollOptionsEdit = ({
  handlePollInputChange,
  number,
  handlePollOptionChange,
  pollOption,
  location
}) => {

    const filterColors = (inputValue) =>
  axios
    .get(`${API_URL}/yelp?term=${inputValue}&location=${location}` )
    .then((response) =>
      response.data.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    )
    .catch((error) => console.log(error));

const promiseOptions = (inputValue) =>
  new Promise((resolve) => {
    setTimeout(() => {
    //   console.log(filterColors(inputValue));
      resolve(filterColors(inputValue));
    }, 1000);
  });

  return (
    <div className="poll-options"><AsyncCreatableSelect value={pollOption} onChange={handlePollOptionChange} isMulti loadOptions={promiseOptions} isDisabled={(pollOption.length) === Number(number)}/>
      
    </div>
  );
};

export default PollOptionsEdit;
